import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
} from "../constants/userConstants";
import axios from "axios";

export const login = (auth, setLoading) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });
    const email = auth.user?.profile.email;
    const serviceId = auth.user?.profile.serviceId;
    const token = auth.user?.access_token;
    const config = {
      headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    };
    const { data } = await axios.post('/api/users/login', { email, serviceId }, config);

    localStorage.setItem("userInfo", JSON.stringify(data));
    setLoading(false);
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });

  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw new Error(error);
  }
};

export const logout = (auth) => async (dispatch) => {
  localStorage.removeItem("userInfo");
  if (auth) {
    // Séquentiel et rattrapé individuellement : lancées en promesses flottantes, une
    // rejection (typiquement revokeTokens sur une session Keycloak déjà détruite) remonte
    // au handler global unhandledrejection d'App.js, qui redirige l'onglet vers /500 au
    // lieu de le déconnecter. L'ordre compte : removeUser efface le jeton dont
    // revokeTokens a besoin.
    await auth.revokeTokens().catch(() => {});
    await auth.removeUser().catch(() => {});
    await auth.clearStaleState().catch(() => {});
    localStorage.removeItem('accessToken');
  }
  dispatch({ type: USER_LOGOUT });
};

export const register = (authUser, firstName, lastName, roles, serviceId, expiredAt, email, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });

    const token = authUser?.access_token;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      "/api/users",
      { firstName, lastName, roles, serviceId, expiredAt, email, password },
      config
    );

    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });

  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Enregistre (ou supprime si signature === null) la signature manuscrite de l'utilisateur, puis met à jour le store et le localStorage
export const updateSignature = (authUser, signature, userInfo) => async (dispatch) => {
  try {
    dispatch({ type: USER_UPDATE_REQUEST });

    const token = authUser?.access_token;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.post("/api/users/signature", { signature }, config);

    const updatedUserInfo = { ...userInfo, signature };
    dispatch({ type: USER_UPDATE_SUCCESS, payload: updatedUserInfo });

    localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
  } catch (error) {
    dispatch({
      type: USER_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateProfile = (authUser, user, userInfo) => async (dispatch) => {
  try {
    dispatch({ type: USER_UPDATE_REQUEST });

    const token = authUser?.access_token;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post("api/users/profile", user, config);

    dispatch({ type: USER_UPDATE_SUCCESS, payload: {...userInfo, ...data,} });

    localStorage.setItem("userInfo", JSON.stringify({...userInfo, ...data,}));
  } catch (error) {
    dispatch({
      type: USER_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
